import { Box, Typography, Button } from "@mui/material";
import NaturePeopleOutlinedIcon from "@mui/icons-material/NaturePeopleOutlined";
import buildRoute from "../components/buildRoute";

import getCurrentUser from "hooks/getCurrentUser";
import { trackEventBeforeNavigation } from "../configureMixpanel";

export function WelcomePage() {
  const currentUser = getCurrentUser();

  console.log("Current User:", currentUser);

  const requestToLogout = () => {
    trackEventBeforeNavigation("logout_clicked", { source: "welcome_page" });
    window.location.href = "/logout/";
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        pt: 4,
      }}
    >
      <NaturePeopleOutlinedIcon
        sx={{ fontSize: 100, color: "primary", mb: 2 }}
      />
      <Typography variant="h2" gutterBottom>
        Welcome to PAD!
      </Typography>
      <Typography variant="body1" align="center" gutterBottom>
        To access all the features of this app, please contact our support team
        using the help button below.
      </Typography>

      {/* Wrap the buttons in a Box with flex row */}
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: 2, // Add spacing between buttons
          marginTop: 4,
        }}
      >
        <Button
          variant="contained"
          color="inherit"
          href="mailto:help@techallies.org"
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            color: "primary.main",
            backgroundColor: "primary.light",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
        >
          Email Support
        </Button>

        <Button
          variant="contained"
          color="inherit"
          onClick={requestToLogout}
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 600,
            color: "primary.main",
            backgroundColor: "primary.light",
            "&:hover": {
              backgroundColor: "grey.300",
            },
          }}
        >
          Log out
        </Button>

        {currentUser.is_superuser && (
          <Button
            variant="contained"
            color="inherit"
            onClick={() => window.location.href = "/control/"}
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: 600,
              color: "primary.main",
              backgroundColor: "primary.light",
              "&:hover": {
                backgroundColor: "grey.300",
              },
            }}
          >
            Control
          </Button>
        )}
      </Box>
    </Box>
  );
}

const routeArgs = {
  element: <WelcomePage />,
};

export default buildRoute(routeArgs);
